
const fold = {

	canvas: null,

	scissors: null,

	width: 73,
	height: 52,


	frameRate: 1000 / 60,

	lastFrame: 0,

	playing: false,

	ticker: 0,


	step: 0,
	targetStep: 0,

	pages: {},

	colors: [
		// [ '#f00', '#f00' ],
		// [ '#00f', '#00f' ],
		// [ '#0f0', '#0f0' ],
		// [ '#eee', '#ccc' ],
		[ '#fff', '#ddd' ],
	],

	currentColor: 0,



	/**
	 *
	 */
	init: function() {

		fold.canvas = new Zdog.Illustration(
			{
				element: '.zdog-canvas',
				// dragRotate: true,
			}
		);

		// Create pages.
		fold.pages.pF = fold.createPage( { parent: fold.canvas, direction: -1 } );
		fold.pages.pB = fold.createPage( { parent: fold.pages.pF, translate: { y: fold.height }, direction: -1 } );
		fold.pages.p5 = fold.createPage( { parent: fold.pages.pB, translate: { y: fold.height }, direction: -1 } );
		fold.pages.p6 = fold.createPage( { parent: fold.pages.p5, translate: { y: fold.height }, direction: -1 } );

		fold.pages.p1 = fold.createPage( { parent: fold.canvas } );
		fold.pages.p2 = fold.createPage( { parent: fold.pages.p1, translate: { y: fold.height } } );
		fold.pages.p3 = fold.createPage( { parent: fold.pages.p2, translate: { y: fold.height } } );
		fold.pages.p4 = fold.createPage( { parent: fold.pages.p3, translate: { y: fold.height } } );

		// Create scissors.
		fold.scissors = fold.createScissors();

		// Update & render.
		fold.canvas.updateRenderGraph();
		fold.animate();

	},


	/**
	 * Create the scissors vectors.
	 *
	 * @param {object} The parameters object.
	 * @return {object}
	 */
	createScissors: function(
		{
			parent = fold.canvas,
		} = {}
	) {

		const color = '#d25';
		const handleHeight = 24;
		const stroke = 10;

		let anchor = new Zdog.Anchor(
			{
				addTo: parent,
			}
		);

		anchor.rotate.y = fold.d2r( 90 );
		// Set the default position offscreen.
		anchor.translate.y = scissorsRest.y;
		anchor.translate.z = scissorsRest.z;

		// Handle 1.
		// ---------
		let anchor1 = new Zdog.Anchor( { addTo: anchor } );

		// Blade.
		new Zdog.Shape(
			{
				addTo: anchor1,
				path: [
					{ x: 10 }, // start at 1st point
					{ x: -65 }, // line to 2nd point
				],
				stroke,
				color,
			}
		);

		// Handle.
		new Zdog.RoundedRect(
			{
				addTo: anchor1,
				width: handleHeight * 1.4,
				height: handleHeight,
				stroke,
				cornerRadius: 50,
				translate: { y: handleHeight * -0.5, x: handleHeight * 1 },
				color
			}
		);

		anchor1.rotate.z = fold.d2r( -20 );


		// Handle 2.
		// ---------
		let anchor2 = new Zdog.Anchor( { addTo: anchor } );

		// Blade.
		new Zdog.Shape(
			{
				addTo: anchor2,
				path: [
					{ x: 10 }, // start at 1st point
					{ x: -65 }, // line to 2nd point
				],
				stroke,
				color,
			}
		);

		// Handle.
		new Zdog.RoundedRect(
			{
				addTo: anchor2,
				width: handleHeight * 1.4,
				height: handleHeight,
				stroke,
				cornerRadius: 50,
				translate: { y: handleHeight * 0.5, x: handleHeight * 1 },
				color
			}
		);

		anchor2.rotate.z = fold.d2r( 20 );


		return anchor;

	},


	/**
	 * Create Page.
	 *
	 * @return {void}
	 */
	createPage: function(
		{
			parent = fold.canvas,
			translate = {},
			direction = 1
		} = {}
	) {

		let anchor = new Zdog.Anchor(
			{
				addTo: parent,
				translate: translate,
			}
		);

		new Zdog.Rect(
			{
				addTo: anchor,
				width: fold.width,
				height: fold.height,
				stroke: 4,
				fill: true,
				color: fold.colors[ fold.currentColor ][ 0 ],
				backface: fold.colors[ fold.currentColor ][ 1 ],
				translate: {
					x: fold.width * 0.5 * direction,
					y: fold.height / 2
				},
			}
		);

		fold.currentColor++;
		if ( fold.currentColor >= fold.colors.length ) {
			fold.currentColor = 0;
		}

		return anchor;

	},


	/**
	 *
	 */
	getStep: function() {

		if ( fold.playing ) {
			return;
		}

		if ( fold.targetStep === fold.step ) {
			return;
		}

		if ( fold.step > fold.targetStep ) {
			fold.step--;
			fold.ticker = 0;
		}

		if ( fold.step < fold.targetStep ) {
			fold.step++;
			fold.ticker = 0;
		}

		fold.playing = true;

		fold.animate();

	},


	/**
	 * Animate everything.
	 *
	 * @param {int} elapsed The time elapsed since the start of the animation.
	 * @return {void}
	 */
	animate: function( elapsed ) {

		const ms = elapsed - fold.lastFrame;

		if ( ms > 0 ) {

			fold.ticker += ms;

			const duration = 50;
			const progress = ( fold.ticker / duration ) / 1000;

			if ( progress > 0.03 ) {
				fold.playing = false;
				fold.getStep();
			}

			if ( progress >= 0.25 ) {
				return;
			}

			if ( fold[ 'step' + fold.step ] ) {
				fold[ 'step' + fold.step ]( progress );
			}

			fold.animateCamera( fold.step, progress );
			fold.animateFolds( fold.step, progress );
			fold.animateColors( fold.step, progress );
			fold.animateScissors( fold.step, progress );

			fold.canvas.updateRenderGraph();

		}

		// animate next frame
		requestAnimationFrame( fold.animate );

		fold.lastFrame = elapsed;

	},


	/**
	 * Animate the scissors.
	 *
	 * @param {int} step The current step number.
	 * @param {int} progress The distance through the animation.
	 * @return {void}
	 */
	animateScissors: function( step, progress ) {

		if ( !scissors[ step ] ) {
			return;
		}

		const s = fold.scissors;
		s.translate.y = Zdog.lerp( s.translate.y, scissors[ step ].y, progress );
		s.translate.z = Zdog.lerp( s.translate.z, scissors[ step ].z, progress );

	},


	/**
	 * Animate the camera.
	 *
	 * @param {int} step The current step number.
	 * @param {int} progress The distance through the animation.
	 * @return {void}
	 */
	animateCamera: function( step, progress ) {

		if ( !camera[ step ] ) {
			return;
		}

		const c = fold.canvas;

		c.zoom = Zdog.lerp( c.zoom, camera[ step ].zoom, progress );

		c.rotate.z = Zdog.lerp( c.rotate.z, fold.d2r( camera[ step ].r.z ), progress );
		c.rotate.y = Zdog.lerp( c.rotate.y, fold.d2r( camera[ step ].r.y ), progress );

		c.translate.x = Zdog.lerp( c.translate.x, camera[ step ].t.x, progress );
		c.translate.y = Zdog.lerp( c.translate.y, camera[ step ].t.y, progress );

	},


	/**
	 * Animate the folding paper.
	 *
	 * @param {int} step The current step number.
	 * @param {int} progress The distance through the animation.
	 * @return {void}
	 */
	animateFolds: function( step, progress ) {

		if ( !folds[ step ] ) {
			return;
		}

		[ 'pF', 'p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'pB' ].forEach(
			pageName => {

				fold.pages[ pageName ].rotate.x = Zdog.lerp( fold.pages[ pageName ].rotate.x, fold.d2r( folds[ step ][ pageName ][ 0 ] ), progress );
				fold.pages[ pageName ].rotate.y = Zdog.lerp( fold.pages[ pageName ].rotate.y, fold.d2r( folds[ step ][ pageName ][ 1 ] ), progress );

			}
		);

	},


	/**
	 * Animate the paper colours.
	 *
	 * @param {int} step The current step number.
	 * @param {int} progress The distance through the animation.
	 * @return {void}
	 */
	animateColors: function( step, progress ) {

		if ( !colours[ step ] ) {
			return;
		}

		[ 'pF', 'p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'pB' ].forEach(
			pageName => {

				fold.pages[ pageName ].children[ 0 ].color = fold.blendColor(
					fold.pages[ pageName ].children[ 0 ].color,
					colours[ step ][ pageName ],
					progress
				);
				fold.pages[ pageName ].children[ 0 ].backface = fold.blendColor(
					fold.pages[ pageName ].children[ 0 ].backface,
					colours[ step ][ pageName ] + 0.2,
					progress
				);

			}
		);

	},


	/**
	 * Blend from a colour to a shade of grey.
	 *
	 * @param {string} current The current colour.
	 * @param {float} target The target value (0 to 1). 0 = white, 1 = black.
	 * @param {int} progress The distance through the animation.
	 * @return {string}
	 */
	blendColor: function( current, target, progress ) {

		let targetValue = parseInt( Math.floor( 255 * ( 1 - target ) ) );
		let startValue = current.toString().replace( '#', '' );
		if ( 6 === startValue.length ) {
			startValue = startValue.substring( 0, 2 );
		} else {
			startValue = startValue.substring( 0, 1 ) + startValue.substring( 0, 1 );
		}
		startValue = parseInt( startValue, 16 );

		// @see https://github.com/metafizzy/zdog/blob/master/js/boilerplate.js#L35-L37
		const targetColor = Zdog.lerp( startValue, targetValue, progress );

		return fold.colorFromValue( targetColor );

	},


	/**
	 * Convert from a colour value (1 to 255) to a hexadecimal shade of grey.
	 *
	 * @param {float} value
	 */
	colorFromValue: function( value ) {

		value = Math.min( value, 255 );
		value = Math.max( value, 0 );
		value = Math.floor( value );

		return '#' + value.toString( 16 ) + value.toString( 16 ) + value.toString( 16 );

	},


	/**
	 *
	 */
	changeStep: function( step ) {

		fold.ticker = 0;
		fold.targetStep = step;

		fold.getStep();

		// fold.animate();

	},


	/**
	 * Degrees to Radians.
	 *
	 * @param {int} degrees The degrees to convert.
	 * @return {number} radians
	 */
	d2r: function( degrees ) {

		return degrees * ( Math.PI / 180 );

	},

};



